var isExtendDate = function isExtendDate(date) {
  if (date instanceof Date) {
    return date;
  }

  if (!date) {
    return '';
  }

  var isTime = /^\d{2}:\d{2}$/.test(date);

  if (isTime) {
    return new Date("".concat(new Date().getFullYear(), " ").concat(date));
  }

  return new Date(date.toString().replace(/-/g, '/'));
};

var parseState = function parseState(props) {
  var date = props.value && isExtendDate(props.value);
  var defaultDate = props.defaultValue && isExtendDate(props.defaultValue);
  var wheelDefault = props.wheelDefaultValue && isExtendDate(props.wheelDefaultValue);
  return {
    date: date || defaultDate,
    wheelDefault: wheelDefault
  };
};

export { isExtendDate, parseState };